module.exports = __webpack_public_path__ + "img/logo-white.fa4ea228.png";